import { render } from "./ScheduleFormWizard.vue?vue&type=template&id=6b683011"
import script from "./ScheduleFormWizard.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormWizard.vue?vue&type=script&lang=ts"
script.render = render

export default script